import { useState } from "react";
import { ActionIcon, Button, Paper, Text } from "@mantine/core";
import { Dropzone, IMAGE_MIME_TYPE } from "@mantine/dropzone";
import { IconFileText, IconUpload, IconX } from "@tabler/icons-react";
import { useFetch } from "../../helpers/useFetch";
import { toast } from "react-hot-toast";

export default function UserDocumentUpload({ documentType, currentUrl, label, slotLabels }) {
  const [slots, setSlots] = useState(Array(slotLabels.length).fill(null));
  const [loading, setLoading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState(currentUrl);

  const handleDrop = (index, files) => {
    const newSlots = [...slots];
    newSlots[index] = { imageFile: files[0], imagePreview: URL.createObjectURL(files[0]) };
    setSlots(newSlots);
  };

  const removeSlot = (index) => {
    const newSlots = [...slots];
    newSlots[index] = null;
    setSlots(newSlots);
  };

  const handleUpload = async () => {
    setLoading(true);
    const fd = new FormData();
    slots.forEach((slot) => slot && fd.append("images[]", slot.imageFile));
    const res = await useFetch(`/user/documents/${documentType}/upload`, "POST", fd, false);
    if (res.status === "ok") {
      setUploadedUrl(res.filePath);
      setSlots(Array(slotLabels.length).fill(null));
      toast.success(`${label} úspěšně nahráno.`);
    } else {
      toast.error(res.error || res.message || "Nastala chyba při nahrávání.");
    }
    setLoading(false);
  };

  const canUpload = slots.every((slot) => slot !== null);

  return (
    <div>
      <Text fw={600} size="sm" mb="xs">
        {label}
      </Text>
      {uploadedUrl ? (
        <Button
          component="a"
          href={uploadedUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="light"
          size="xs"
          leftSection={<IconFileText size={14} stroke={1.5} />}>
          Zobrazit nahraný dokument
        </Button>
      ) : (
        <>
          <div className="flex flex-wrap gap-3">
            {slotLabels.map((slotLabel, i) => (
              <div key={i}>
                <Text size="xs" c="dimmed" mb={4}>
                  {slotLabel}
                </Text>
                {slots[i] ? (
                  <Paper className="relative h-[100px] w-[100px] overflow-hidden rounded-md" withBorder>
                    <ActionIcon
                      variant="filled"
                      className="absolute left-2 top-2"
                      color="red"
                      size="sm"
                      onClick={() => removeSlot(i)}>
                      <IconX size={14} stroke={1.5} />
                    </ActionIcon>
                    <img className="h-full w-full object-cover object-center" src={slots[i].imagePreview} />
                  </Paper>
                ) : (
                  <Dropzone
                    onDrop={(files) => handleDrop(i, files)}
                    accept={IMAGE_MIME_TYPE}
                    maxFiles={1}
                    loading={loading}
                    className="flex h-[100px] w-[100px] cursor-pointer items-center justify-center rounded-md duration-100 hover:scale-105">
                    <Dropzone.Idle>
                      <IconUpload stroke={1.5} size={36} />
                    </Dropzone.Idle>
                    <Dropzone.Accept>
                      <IconUpload stroke={1.5} size={36} />
                    </Dropzone.Accept>
                    <Dropzone.Reject>
                      <IconX stroke={1.5} size={36} color="red" />
                    </Dropzone.Reject>
                  </Dropzone>
                )}
              </div>
            ))}
          </div>
          <Button mt="sm" size="sm" onClick={handleUpload} loading={loading} disabled={!canUpload}>
            Nahrát
          </Button>
        </>
      )}
    </div>
  );
}
